import * as Yup from "yup";

export const brandsSchema = Yup.object().shape({
  marca: Yup.string().required("Este campo es obligatorio"),
});
